export default __webpack_public_path__ + "static/media/icon-car.e89e81a0.svg";